export default __webpack_public_path__ + "static/media/arrow.ad3ba631.png";